import { CanActivateFn, Router, ActivatedRouteSnapshot } from '@angular/router';
import { inject } from '@angular/core';
import { AuthorizationService } from 'src/app/shared/services/authorization.service';

export const authorizationGuard: CanActivateFn = (route: ActivatedRouteSnapshot) => {
  const auth = inject(AuthorizationService);
  const router = inject(Router);

  const isLogged = auth.isLoggedIn?.() ?? true;

  const allowed: string[] | undefined = route.data?.['allowedRoles'];
  const okRole = !allowed || allowed.some(r => auth.userHasRole?.(r));

  return (isLogged && okRole) || router.parseUrl('/access-denied');
};